import { Label } from "@xola/ui-kit";
import { SwitchField } from "common";
import { useFormikContext } from "formik";
import React, { useMemo } from "react";
import { FraudPreference, ProductObject, SelectionState } from "types";
import { ProductSelectorModal } from "@/components/Common/ProductSelectorModal";
import { SelectedProductListInput } from "@/components/Common/SelectedProductListInput";
import { useModal } from "@/hooks/useVisibility";
import { getSelectedExperiences, getSelectionState } from "@/models/SelectionState";

interface FormValues {
    fraud: FraudPreference;
}

const DEFAULT_SELECTED_EXPERIENCES = { all: false, experiences: [] };

export const PreCheckSection = () => {
    const productSelectorModal = useModal(false);
    const { values, setFieldValue } = useFormikContext<FormValues>();

    const isEnabled = values.fraud.identityVerification?.enabled ?? false;

    const selectedProducts = useMemo(() => {
        const selectedExperiences =
            values.fraud.identityVerification.selectedExperiences ?? DEFAULT_SELECTED_EXPERIENCES;
        return getSelectionState(selectedExperiences);
    }, [values.fraud.identityVerification.selectedExperiences]);

    const handleConfirm = (selection: SelectionState) => {
        setFieldValue("fraud.identityVerification.selectedExperiences", getSelectedExperiences(selection));
    };

    return (
        <div data-testid="fraud-fighter-pre-check-section">
            <Label>Enable Pre-Check</Label>
            <SwitchField
                isChecked={isEnabled}
                onChange={(isChecked: boolean) => setFieldValue("fraud.identityVerification.enabled", isChecked)}
            >
                Collect photo ID and live selfie from the booking organizer prior to arrival
            </SwitchField>

            {isEnabled && (
                <div className="mt-4">
                    <SelectedProductListInput
                        label="Products"
                        labelTooltipContent="Select experiences where Pre-Check will be required"
                        selectedProducts={selectedProducts}
                        onEditClick={productSelectorModal.toggle}
                    />

                    <ProductSelectorModal
                        allowEmptySelection
                        isOpen={productSelectorModal.isVisible}
                        value={selectedProducts}
                        objects={[ProductObject.EXPERIENCE]}
                        onClose={productSelectorModal.hide}
                        onConfirm={handleConfirm}
                    />
                </div>
            )}
        </div>
    );
};
